import React, { FC } from 'react';

import { Reup_Product } from '@/graphql/types';
import { PurchaseOrder } from '@/types';
import {
  HandleAutoCompleteDraftOrderCallback,
  HandleDeleteOrders,
  HandleLineItemQuantityUpdated,
  HandleLineItemRemove,
  HandleNoteUpdate,
  HandleSelectedOrdersChange,
} from '@/types/draftOrderTypes';

import DraftOrdersTable from './draftOrdersTable';

type DraftOrdersListPageProps = {
  purchaseOrders: PurchaseOrder[];
  onLineItemRemoved: HandleLineItemRemove;
  onLineItemQuantityUpdated: HandleLineItemQuantityUpdated;
  onDeleteOrders: HandleDeleteOrders;
  selectedOrders: PurchaseOrder[];
  onSelectedOrdersChange: HandleSelectedOrdersChange;
  products: Reup_Product[];
  onAutoCompleteSelect: HandleAutoCompleteDraftOrderCallback;
  onNoteUpdate: HandleNoteUpdate;
};

const DraftOrdersListPage: FC<DraftOrdersListPageProps> = ({
  purchaseOrders,
  selectedOrders,
  products,
  onLineItemRemoved,
  onLineItemQuantityUpdated,
  onSelectedOrdersChange,
  onAutoCompleteSelect,
  onDeleteOrders,
  onNoteUpdate,
}) => {
  return (
    <DraftOrdersTable
      purchaseOrders={purchaseOrders}
      onLineItemRemoved={onLineItemRemoved}
      onNoteUpdate={onNoteUpdate}
      onLineItemQuantityUpdated={onLineItemQuantityUpdated}
      onSelectedOrdersChange={onSelectedOrdersChange}
      products={products}
      onAutoCompleteSelect={onAutoCompleteSelect}
    />
  );
};

export default DraftOrdersListPage;
